"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoModal = exports.item = void 0;
var React = require("react");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
exports.item = [
    'buyer',
    // 'printOrders',
    'suitabilityAndFinancialProposals',
    //  'registration',
    'doNotReceiveTenders',
    'lockTenders',
    'openingEvent',
    'questionsAndAnswers',
    'reliablePartnerReport'
];
var enhance = (0, recompose_1.compose)((0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.selected !== null ||
            this.props.selected !== prevProps.selected) {
            window.requestAnimationFrame(function () {
                var selectedItem = document.querySelector('.item-' + _this.props.selected);
                if (selectedItem) {
                    selectedItem.scrollIntoView(true);
                }
            });
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.selected !== null ||
            this.props.selected !== nextProps.selected) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var InfoHeader = function (props) { return (React.createElement(React.Fragment, null, (0, translation_1.getLocalization)("bid/infoModal/info"))); };
var InfoBody = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "icon fa-stack fa-2x" },
        React.createElement(sok_ui_1.Icon, { className: "fa-light fa-circle fa-stack-2x blue", prefix: 'fal' }),
        React.createElement(sok_ui_1.Icon, { className: "fa-light fa-exclamation fa-stack-1x black", prefix: 'fa' })),
    React.createElement("div", { className: 'right-column' }, exports.item.map(function (item) { return (React.createElement("div", { className: 'row' },
        React.createElement("div", { key: "pos-".concat(item), className: classNames('item-' + item, 'spacer') }),
        React.createElement("div", { key: "data-".concat(item), className: classNames('info-row', item === props.selected && 'selected') },
            React.createElement("div", { className: 'title' }, (0, translation_1.getLocalization)("bid/infoModal/".concat(item, "/title"))),
            React.createElement("div", { className: 'message' }, (0, translation_1.getLocalization)("bid/infoModal/".concat(item, "/message")))))); })))); };
var InfoFooter = function (props) { return (React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: props.onClose }, (0, translation_1.getLocalization)("buttons/close"))); };
exports.InfoModal = enhance(function (props) { return (React.createElement(ConfirmDialog_1.ConfirmDialog, { isOpen: props.selected !== null, close: props.onClose, className: 'bid-basic-information-info-modal', header: React.createElement(InfoHeader, __assign({}, props)), body: React.createElement(InfoBody, __assign({}, props)), footer: React.createElement(InfoFooter, __assign({}, props)) })); });
